import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { PageEventArgs, GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems, RowDeselectEventArgs, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { EstadoService, MedioPagoService, MonedaService, MovimientoService, TipoMovimientoService, MenuFuncionService, TenantService, ConsorcioService, ComunidadService, UnidadFuncionalService, ProveedorService } from '../../../../src/app/shared/services';
import { GridPageSettings, MedioPago, MenuFuncionCodes, Moneda, Movimiento, SearchEstadoRequest, SearchMedioPagoRequest, SearchMonedaRequest, Estado, TenantFeatureFlags, LocalStorageKeys, SearchUnidadFuncionalRequest, UnidadFuncional, SearchConsorcioRequest, SearchComunidadRequest, Consorcio, Comunidad, SearchProveedorRequest, Proveedor, TenantEnum,
  SearchMovimientoRequest, SearchTipoMovimientoRequest, TipoMovimiento, EstadoConstants, SearchMovimientoItemDto
} from '../../../../src/app/shared/model';

import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-miMovimientoLista',
  templateUrl: './miMovimientoLista.component.html',
  styles: []
})

export class MiMovimientoListComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  public format = { type:'date', format:'dd/MM/yyyy HH:mm' }
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isCancelling: boolean = false;
  isTipoSearching: boolean = false;
  isEstadoSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isMedioPagoSearching: boolean = false;
  isStatisticsSearching: boolean = false;
  isRejecting: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;

  multiSelectionEnabled: boolean = false;
  isRosbaco: boolean = false;
  TenantEnum = TenantEnum;

  canAdd: boolean = false;
  canView: boolean = false;
  canFinanciar: boolean = false;
  canCancelar: boolean = false;
  canAddDeuda: boolean = false;
  canViewDetail: boolean = false;
  canAnalizarDocs: boolean = false;
  canRecurrentes: boolean = false;

  verSoloActivos: boolean = true;

  tipoMiMovimientoList: TipoMovimiento[];
  monedaList: Moneda[];
  estadoList: Estado[];
  medioPagoList: MedioPago[];
  categoriaList: any[];
  consorcioList: Consorcio[];
  comunidadList: Comunidad[];
  ufList: UnidadFuncional[];
  filteredProveedorList: Proveedor[] = [];

  tenantFeatureFlags: TenantFeatureFlags;

  public query: Query;
  public totales: any[];
  public totalesSaldos: any[];
  public totalesSeleccionados: any[] = [];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private service: MovimientoService,
    private tipoMovimientoService: TipoMovimientoService,
    private monedaService: MonedaService,
    private estadoService: EstadoService,
    private tenantService: TenantService,
    private medioPagoService: MedioPagoService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private proveedorService: ProveedorService,
    private datePipe: DatePipe
  ) {
    this.isRosbaco = this.sharedFunctions.isRosbacoUser();
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.MIS_MOVIMIENTOS_LIST).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {

        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canView = true;
            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();

    this.getTiposMovimiento();
    // this.getEstados();
    this.getCategorias();
    this.getMonedas();
    this.getMediosPago();
    // this.getConsorcios();
    this.getComunidades();
    // this.getProveedoresAutocomplete();

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getMySearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getSearchEstadisticas();
  }

  buildForm() {
    var fechaHoy = new Date();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [fechaHoy],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'Proveedor': [null],

      'PedidoId': [null],
      'Contrato': [null],

      'Detalle': [null],
      'TipoMovimientoId': [null],
      'MonedaId': [null],
      'Estados': [null],
      'MedioPagoId': [null],
      'Signo': [null],
      'VerSoloDeudasPendientes': [null],
      'VerSoloActivos': [true],
      'gridPage': [1]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-miMovimientoLista");

    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }
  }

  isProcessing() {
    return (this.isCancelling || this.isSearching || this.isExporting);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
            this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  getProveedoresAutocomplete() {
    this.searchForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  getTiposMovimiento() {
    this.isTipoSearching = true;
    let searchAllTiposMovimiento = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.tipoMovimientoService.search(searchAllTiposMovimiento).subscribe(data => {
      this.isTipoSearching = false;
      if (data != null)
        this.tipoMiMovimientoList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getCategorias() {
    this.categoriaList = [
      { Id: -1, Nombre: "Ver solo deudas" },
      { Id: 1, Nombre: "Ver solo pagos" }
    ];
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    this.isMonedaSearching = true;
    let searchAllMonedas = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.monedaService.search(searchAllMonedas).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getEstados() {
    let searchAllEstado = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(searchAllEstado).subscribe(data => {
      this.isEstadoSearching = false;
      if (data != null)
        this.estadoList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getMediosPago() {
    this.isMedioPagoSearching = true;
    let searchAllMedioPago = new SearchMedioPagoRequest(null, null, true, "Nombre", null, null, true);

    this.medioPagoService.search(searchAllMedioPago).subscribe(data => {
      this.isMedioPagoSearching = false;
      if (data != null)
        this.medioPagoList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isMedioPagoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  compareEstados(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  onSearch() {
    this.multiSelectionEnabled = false;
    this.isSearching = true;

    this.searchForm.get('gridPage')?.setValue(1);
    this.sharedFunctions.setReporteFiltros("app-miMovimientoLista", this.searchForm.getRawValue());

    this.setQueryParams();

    this.getSearchEstadisticas();
    this.grid.refresh();

    this.totalesSeleccionados = [];
    this.isSearching = false;
  }

  getSearchEstadisticas() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value,
      ... {
        ProveedorId: this.searchForm.get("Proveedor")?.value?.Id
      }
    };

    this.isStatisticsSearching = true;
    this.service.getMySearchEstadisticas(search).subscribe(data => {
      this.isStatisticsSearching = false;
      if (data.Success) {
        this.totales = data.Result.Totales;
        this.totalesSaldos = data.Result.TotalesSaldos;
      }
    },
    (err: HttpErrorResponse) => {
      this.isStatisticsSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "MedioPagoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MedioPagoId;
    else
      this.query.addParams("MedioPagoId",this.searchForm.value.MedioPagoId);

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoDesde", this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoHasta", this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoDesde", this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoHasta", this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "Estados");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Estados?.join(",");
    else
      this.query.addParams("Estados", this.searchForm.value.Estados?.join(","));

    index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId",this.searchForm.value.PedidoId);

    index = this.query.params.findIndex(obj => obj.key === "Contrato");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Contrato;
    else
      this.query.addParams("Contrato",this.searchForm.value.Contrato);

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "Detalle");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Detalle;
    else
      this.query.addParams("Detalle",this.searchForm.value.Detalle);

    index = this.query.params.findIndex(obj => obj.key === "TipoMovimientoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMovimientoId;
    else
      this.query.addParams("TipoMovimientoId",this.searchForm.value.TipoMovimientoId);

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Proveedor?.Id;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.Proveedor?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "Usuario");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Usuario;
    else
      this.query.addParams("Usuario",this.searchForm.value.Usuario);

    index = this.query.params.findIndex(obj => obj.key === "NroDocumento");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.NroDocumento;
    else
      this.query.addParams("NroDocumento",this.searchForm.value.NroDocumento);

    index = this.query.params.findIndex(obj => obj.key === "MailContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MailContacto;
    else
      this.query.addParams("MailContacto",this.searchForm.value.MailContacto);

    index = this.query.params.findIndex(obj => obj.key === "MovilContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MovilContacto;
    else
      this.query.addParams("MovilContacto",this.searchForm.value.MovilContacto);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloDeudasPendientes");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloDeudasPendientes;
    else
      this.query.addParams("VerSoloDeudasPendientes",this.searchForm.value.VerSoloDeudasPendientes);

    index = this.query.params.findIndex(obj => obj.key === "Signo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Signo;
    else
      this.query.addParams("Signo",this.searchForm.value.Signo);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos;
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos);
  }

//#region grid

  onActionBegin(args: PageEventArgs) {
    if (args.requestType === 'paging' && !this.isSearching)
    {
      this.totalesSeleccionados = [];
      this.searchForm.get('gridPage')?.setValue(args.currentPage);
      this.sharedFunctions.setReporteFiltros("app-miMovimientoLista", this.searchForm.getRawValue());
    }
  }

  public onRowSelect(args: RowSelectEventArgs): void {
    this.calcularTotalSeleccionado();
  }

  onRowDeselected(args: RowDeselectEventArgs): void {
    this.calcularTotalSeleccionado();
  }

//#endregion

  onDeudaFiltroUfComunidadSelect() {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    this.searchForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  edit(item: Movimiento) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['mi-movimiento-view', item.Id]);
  }

  financiar() {
    if (this.canFinanciar) {
      this.router.navigate(['movimiento-financiacion']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para financiar deudas", "Error");
    }
  }

  onExport() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value,
      ...{
        ProveedorId: this.searchForm.get("Proveedor")?.value?.Id
      }
    };

    this.isExporting = true;
    this.service.exportMisMovmientos(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Movimientos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getEstadoBackgroundColor(item: SearchMovimientoItemDto) {
    return (item != null && item.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO ? 'indianred' : 'black');
  }

  calcularTotalSeleccionado() {
    this.totalesSeleccionados = [];
    var multiSelection = this.grid.getSelectedRecords();

    if (multiSelection != null && multiSelection.length > 0) {
      for (var i=0; i<multiSelection.length; i++) {
        var item = (multiSelection[i] as any);
        var index = this.totalesSeleccionados.findIndex(v => v.key == item.Moneda);

        if (index == null || index < 0) {
          this.totalesSeleccionados.push({ key: item.Moneda, value: 0 });
          index = this.totalesSeleccionados.length - 1;
        }

        this.totalesSeleccionados[index].value += parseFloat(item.Monto);
      }
    }
  }
}
